export default __webpack_public_path__ + "static/media/icon-checkbox.87344bf7.svg";